import { FC, memo, useMemo } from 'react'
import { Select } from '@chakra-ui/react'

type Props = {
  limit: number
  onChangeLimit: (newLimit: number) => void
}

const PaginationLimitSelect: FC<Props> = ({ limit, onChangeLimit }) => {
  const pageLimitsOptions = useMemo(() => {
    return [
      { value: 15, label: '15 / página' },
      { value: 30, label: '30 / página' },
      { value: 50, label: '50 / página' },
      { value: 100, label: '100 / página' },
    ]
  }, [])

  return (
    <Select
      minW="max-content"
      maxW="max-content"
      aria-label="Opções de limit de paginação."
      onChange={({ target }) => onChangeLimit(Number(target.value))}
      defaultValue={limit}
      gap={1}
    >
      {pageLimitsOptions.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </Select>
  )
}

export default memo(PaginationLimitSelect)
